import React, { useState, useEffect } from "react";
import "./settingsAccount.css";
import NarrowPasswordField from "../../../components/input/new/narrowPasswordField";
import { supabase } from "../../../supabaseClient";

export default function SettingsAccount() {
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  useEffect(() => {
    // on mount, grab the current user from Supabase
    supabase.auth.getUser().then(({ data: { user }, error }) => {
      if (error) {
        console.error("Failed to fetch user:", error);
      } else {
        setEmail(user?.email ?? "");
      }
    });
  }, []);

  const handleSavePassword = async () => {
    setPasswordError("");
    setPasswordSuccess("");

    // basic client‐side checks
    if (!currentPassword) {
      setPasswordError("Please enter your current password.");
      return;
    }
    if (!newPassword) {
      setPasswordError("Please enter a new password.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError("New passwords do not match.");
      return;
    }

    // Optional: re-authenticate to verify current password
    const { data: signInData, error: signInError } =
      await supabase.auth.signInWithPassword({
        email,
        password: currentPassword,
      });
    if (signInError) {
      setPasswordError("Current password is incorrect.");
      return;
    }

    // Now update the password
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    if (error) {
      setPasswordError(error.message);
    } else {
      setPasswordSuccess("Password updated successfully.");
      // clear fields
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <div className="settings-account">
      <h1 className="settings-account__title">Account</h1>

      {/* Email */}
      <div className="settings-account__field">
        <div className="settings-account__label">Current logged in email</div>
        <div className="settings-account__value">
          {email || "—"}
          <span className="settings-account__verified">
            ✔ <p className="settings-account__value">VERIFIED</p>
          </span>
        </div>
      </div>

      <div className="settings-account__divider" />

      {/* Phone */}
      <div className="settings-account__field">
        <div className="settings-account__label">Phone number</div>
        <div className="settings-account__desc">
          Adding and verifying your phone number allows two-step verification to
          be turned on.
          <button className="settings-account__link">Add</button>
        </div>
      </div>

      <div className="settings-account__divider" />

      {/* Change Password */}
      <div className="settings-account__section">
        <div className="settings-account__section-title">
          Change your password
        </div>

        <div className="settings-account__form-row">
          <NarrowPasswordField
            title="Current password"
            placeholder="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="settings-account__input"
          />
          <button className="settings-account__forgot">Forgot password</button>
        </div>

        <div className="settings-account__form-col">
          <NarrowPasswordField
            title="New password"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="settings-account__input"
          />

          <NarrowPasswordField
            title="Confirm new password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="settings-account__input"
          />

          {passwordError && (
            <p className="settings-account__error">{passwordError}</p>
          )}
          {passwordSuccess && (
            <p className="settings-account__success">{passwordSuccess}</p>
          )}

          <button
            className="settings-account__save"
            disabled={
              !currentPassword ||
              !newPassword ||
              newPassword !== confirmPassword
            }
            onClick={handleSavePassword}
          >
            Update password
          </button>
        </div>
      </div>

      <p className="help-text" style={{ marginTop: "100px" }}>
        Need help?
      </p>
    </div>
  );
}
